import styled, { css } from 'styled-components';

interface RadioProps {
  isSelected?: boolean;
}

export const Container = styled.div<RadioProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1.4px solid #d5d5d6;
  border-radius: 8px;
  height: 54px;
  padding: 0 12px;
  margin: 6px 0;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1.8px solid #004f92;
      background-color: rgba(235, 241, 247, 255);
    `}

  img {
    width: 14px;
    height: 14px;
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    width: 80%;
    font-size: 16px;
    font-weight: ${theme.fontWeight.medium};
    color: #555658;
  `}
`;

export const RadioButton = styled.div<RadioProps>`
  display: flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #d5d5d6;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: #004f92;
    `}

  img {
    width: 14px;
    height: 14px;
  }

  div {
    background-color: #ffffff;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
`;
